// @flow
import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';
import Input from '../../components/Input';
import { FirstChild } from '../../helpers';

import { noValidate } from '../../helpers';

type Props = {
  isSaving: boolean,
  settings: Object,
  successMsg: string,
  errorMsg: string,
  handleSubmit: (v: Object) => void
};

const SettingsUMBookingConfigForm = (props: Props) => (
  <Form onSubmit={props.handleSubmit}>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="UM Booking URL"
          placeholder={
            props.settings && props.settings.umSystem
              ? props.settings.umSystem.description
              : ''
          }
          name="umSystem.value"
          validate={[noValidate]}
        />
        <Field
          component={Input}
          type="text"
          label="Default UM Costs"
          placeholder={
            props.settings && props.settings.indicativeUmRate
              ? props.settings.indicativeUmRate.description
              : ''
          }
          name="indicativeUmRate.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12}>
        <Button
          bsStyle="primary"
          type="submit"
          className="relative-padding"
          disabled={props.isSaving}
        >
          {props.isSaving ? 'Saving...' : 'Save'}
        </Button>
      </Col>
    </Row>
    <br />
    <Row>
      <Col sm={12}>
        <CSSTransitionGroup
          component={FirstChild}
          transitionName="fade"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {props.successMsg ? (
            <p key="success" className="text-success">
              {props.successMsg}
            </p>
          ) : null}
        </CSSTransitionGroup>
      </Col>
    </Row>
    {props.errorMsg && (
      <div className="alert alert-danger">{props.errorMsg}</div>
    )}
  </Form>
);

export default reduxForm({
  form: 'settingsUMBookingConfigForm'
})(SettingsUMBookingConfigForm);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsUMBookingConfigForm.js